// «رابط الحجز وQR» — a row of the المواعيد module menu (HANDOFF-erp-web §3
// row 4 → business app §5.13). Manager+ (business handoff §9: the hub's
// «الصفحة» group). Online only: the public page, its QR and the scan
// figures live in the cloud (bff-business GET /v1/business/qr); a node
// (ERP_MODE=node) has no public page, so the row is absent there.
//
// Integrator: spread `pageRoutes` into the booking module's `routes`,
// `pageMenu` into its `menu`, and `./mock/handlers` `handlers` into
// src/features/booking/mock/handlers.ts.

import type { RouteObject } from 'react-router-dom';
import { gate, type Gate, type MenuItem } from '@/app/module-types';

export const PAGE_PATH = '/page';

const pageGate: Gate = { flag: 'erp.core', minRole: 'manager', modes: ['online'] };

export const pageRoutes: RouteObject[] = [
  {
    path: PAGE_PATH,
    lazy: () => import('./screens/BookingPage').then((m) => ({ Component: m.BookingPageRoute })),
    handle: gate(pageGate),
  },
];

export const pageMenu: MenuItem[] = [{ key: 'page', label: 'رابط الحجز وQR', to: PAGE_PATH, ...pageGate }];
